import React from 'react';
import PageHero from '../../components/ui-shree/PageHero';
import AdminShell from '../../components/Admin';

const AdminPage = () => (
  <div data-testid="admin-page">
    <PageHero
      overline="Dharma Economy · Command Center"
      title={
        <>
          The <em className="text-[#90B0BF]">watchful</em>
          <br />
          house keeper.
        </>
      }
      subtitle="Read-only oversight of the entire Shreesavaa ecosystem — token issuance, cost-plus pricing, the global vessel registry, batch provenance, partner onboarding, and community moderation. No manual minting. Every SEVA is traced to a physical event."
      testId="admin-hero"
    />
    <section className="px-6 md:px-12 pb-32">
      <div className="max-w-[1400px] mx-auto">
        <AdminShell />
      </div>
    </section>
  </div>
);

export default AdminPage;
